var _rect, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-87"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.03,
    y: 48.01,
    width: 125.64,
    height: 85.64,
    style: {
      fill: "none",
      stroke: "#ebebeb",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.43,53.1a2.52,2.52,0,1,1-2.52-2.53A2.52,2.52,0,0,1,115.43,53.1Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.73,53.1a2.52,2.52,0,1,1-2.52-2.53A2.52,2.52,0,0,1,125.73,53.1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,53.1a2.52,2.52,0,1,1-2.52-2.53A2.52,2.52,0,0,1,136,53.1Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.03,
    y1: 58.03,
    x2: 231.67,
    y2: 58.03,
    style: {
      fill: "none",
      stroke: "#ebebeb",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 657.29,
    width: 1.57,
    height: 74.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 653.7,
    y: 67.14,
    width: 8.75,
    height: 5.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 653.7,
    y: 69.11,
    width: 8.75,
    height: 3.95,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.82,112.22a6.74,6.74,0,1,1-6.74-6.74A6.74,6.74,0,0,1,664.82,112.22Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "680.01 112.22 636.15 112.22 644.1 98.14 650.58 72.01 665.59 72.01 672.07 98.14 680.01 112.22",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.74,
    width: 1.57,
    height: 60.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 572.15,
    y: 53.29,
    width: 8.75,
    height: 5.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 572.15,
    y: 55.26,
    width: 8.75,
    height: 3.95,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.27,98.38a6.74,6.74,0,1,1-6.74-6.74A6.74,6.74,0,0,1,583.27,98.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "598.46 98.38 554.6 98.38 562.54 84.3 569.02 58.16 584.04 58.16 590.52 84.3 598.46 98.38",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 497.51,
    width: 1.57,
    height: 45.85,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.92,
    y: 38.83,
    width: 8.75,
    height: 5.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.92,
    y: 40.8,
    width: 8.75,
    height: 3.95,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505,83.92a6.74,6.74,0,1,1-6.74-6.74A6.74,6.74,0,0,1,505,83.92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "520.23 83.92 476.37 83.92 484.31 69.84 490.79 43.7 505.81 43.7 512.29 69.84 520.23 83.92",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5,154.61a3.16,3.16,0,0,1,3.3,0c.28.16.56.33.85.48s.58.3.87.44a3.12,3.12,0,0,1,1.84,2.73l.13,4.06,13.23-.41-.12-4.06A3.13,3.13,0,0,1,89.26,155a18.07,18.07,0,0,0,1.68-1,3.15,3.15,0,0,1,3.29-.21l3.57,1.92L104.06,144l-3.58-1.91a3.17,3.17,0,0,1-1.64-2.85,18.71,18.71,0,0,0-.06-2,3.12,3.12,0,0,1,1.46-3l3.45-2.14-7-11.25-3.47,2.15a3.14,3.14,0,0,1-3.29,0c-.28-.17-.56-.33-.85-.48s-.57-.3-.87-.44a3.14,3.14,0,0,1-1.84-2.74l-.13-4.07L73,115.74l.13,4.05a3.13,3.13,0,0,1-1.66,2.85,18.16,18.16,0,0,0-1.68,1,3.15,3.15,0,0,1-3.29.21L63,122,56.7,133.65l3.57,1.92a3.13,3.13,0,0,1,1.64,2.86q0,1,.06,2a3.12,3.12,0,0,1-1.46,3l-3.44,2.13,7,11.25Zm3.31-20.89a10.85,10.85,0,1,1,4.44,14.68A10.86,10.86,0,0,1,70.81,133.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.24,254.3a2.17,2.17,0,0,1,2-1.08h1.37a2.17,2.17,0,0,1,2,1.07l1.43,2.47,8-4.64-1.42-2.46a2.19,2.19,0,0,1,.08-2.31q.38-.58.69-1.2a2.21,2.21,0,0,1,2-1.22h2.84v-9.28h-2.84a2.2,2.2,0,0,1-2-1.21,12.88,12.88,0,0,0-.69-1.2,2.19,2.19,0,0,1-.08-2.31l1.42-2.47-8-4.63-1.43,2.47a2.22,2.22,0,0,1-2,1.08c-.23,0-.46,0-.68,0s-.46,0-.69,0a2.21,2.21,0,0,1-2-1.08l-1.42-2.47-8,4.63,1.42,2.46a2.19,2.19,0,0,1-.08,2.31q-.37.59-.69,1.2a2.2,2.2,0,0,1-2,1.22h-2.84v9.28h2.84a2.21,2.21,0,0,1,2,1.22,11.7,11.7,0,0,0,.69,1.2,2.21,2.21,0,0,1,.08,2.32l-1.42,2.45,8,4.64Zm-4.88-14a7.6,7.6,0,1,1,7.61,7.59A7.61,7.61,0,0,1,669.36,240.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.38,166.32a2.19,2.19,0,0,1,1.08,2c0,.23,0,.46,0,.69s0,.46,0,.68a2.19,2.19,0,0,1-1.07,2l-2.47,1.43,4.63,8,2.47-1.42a2.19,2.19,0,0,1,2.31.08q.58.38,1.2.69a2.21,2.21,0,0,1,1.22,2v2.84H126v-2.84a2.21,2.21,0,0,1,1.22-2q.62-.32,1.2-.69a2.19,2.19,0,0,1,2.31-.08l2.47,1.42,4.63-8-2.47-1.43a2.22,2.22,0,0,1-1.08-2c0-.23,0-.46,0-.68s0-.46,0-.69a2.21,2.21,0,0,1,1.08-2l2.47-1.42-4.63-8-2.46,1.42a2.19,2.19,0,0,1-2.31-.08,13,13,0,0,0-1.21-.69,2.21,2.21,0,0,1-1.22-2v-2.84h-9.27v2.84a2.21,2.21,0,0,1-1.22,2,13,13,0,0,0-1.21.69,2.19,2.19,0,0,1-2.31.08l-2.46-1.42-4.63,8Zm14-4.88a7.6,7.6,0,1,1-7.59,7.61A7.61,7.61,0,0,1,121.38,161.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.78,
    y: 221.69,
    width: 97.79,
    height: 181.87,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.04,
    y: 216.67,
    width: 107.26,
    height: 5.02,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.3,
    y: 216.67,
    width: 33.73,
    height: 5.02,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.57,
    y: 221.69,
    width: 33.13,
    height: 181.87,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.43,
    y: 295.56,
    width: 76.49,
    height: 43.12,
    style: {
      fill: "none",
      stroke: "#c7c7c7",
      strokeMiterlimit: 10,
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.97,
    y: 308.11,
    width: 14.94,
    height: 8.59,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.38,
    y: 308.76,
    width: 14.94,
    height: 7.29,
    style: {
      fill: "none",
      stroke: "#c7c7c7",
      strokeMiterlimit: 10,
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.43,
    y: 350.04,
    width: 76.49,
    height: 43.12,
    style: {
      fill: "none",
      stroke: "#c7c7c7",
      strokeMiterlimit: 10,
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.97,
    y: 362.59,
    width: 14.94,
    height: 8.59,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.38,
    y: 363.24,
    width: 14.94,
    height: 7.29,
    style: {
      fill: "none",
      stroke: "#c7c7c7",
      strokeMiterlimit: 10,
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.43,
    y: 241.08,
    width: 76.49,
    height: 43.12,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.24,
    y: 230.03,
    width: 58.23,
    height: 42.21,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.81 225.66 96.24 225.66 96.24 230.03 118 230.03 116.81 225.66",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.31 272.24 96.09 272.24 91.6 233.53 149.82 233.53 154.31 272.24",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.71 229.53 91.13 229.53 91.6 233.53 113.35 233.53 111.71 229.53",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.58,
    y: 241.08,
    width: 76.49,
    height: 43.12,
    style: {
      fill: "#ebebeb",
      stroke: "#c7c7c7",
      strokeMiterlimit: 10,
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.12,
    y: 253.63,
    width: 14.94,
    height: 8.59,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.53,
    y: 254.28,
    width: 14.94,
    height: 7.29,
    style: {
      fill: "none",
      stroke: "#c7c7c7",
      strokeMiterlimit: 10,
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.26,
    y: 247.54,
    width: 36.66,
    height: 36.66,
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-87"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 375,
    cy: 444.69,
    rx: 317.16,
    ry: 22.55,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-87"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M635,290.54a92.1,92.1,0,0,1,2.12-15c1.06-4.43,2.56-9,5.35-12.62,2.55-3.34,6.22-6,10.48-6.53s8,1.33,11,3.91c3.81,3.21,6.72,7.45,9.45,11.56a143.18,143.18,0,0,1,8.17,14.29c.08.16-.17.3-.25.14a88.07,88.07,0,0,0-7.3-12,75.93,75.93,0,0,0-8.41-10.18c-2.82-2.75-6.4-5.32-10.48-5.45s-7.81,2.15-10.26,5.28c-2.73,3.5-4.12,7.87-5.16,12.13a90.22,90.22,0,0,0-2.11,14.25c-.8,9.86-1,19.77-1.24,29.66-.13,5.59-.2,11.19-.25,16.78,0,2.84-.05,5.67-.07,8.51a52.19,52.19,0,0,1-.33,8.2c-.09.55-1,.49-1.09,0a47.94,47.94,0,0,1-.37-7.77c0-2.69-.07-5.37-.1-8.06,0-5.22-.07-10.45-.06-15.67C634.13,311.53,634.25,301,635,290.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.05,283.11c.53-2.79,1.47-6.43,3.06-8.58,2.85-3.89,5.93-2.2,3.08,2.1a25.52,25.52,0,0,0-4,10.6s4.79,6.85,10.58,10.22c-.24-2.63-1-6.68-.47-10.59,1.11-8.47,6.23-8,5-1.27-1,5.4-1.43,11.12-1.16,13.6a29.32,29.32,0,0,0,6.19,3c-.33-1-.68-2.16-1.07-3.59-2.06-7.59,3-10,3.17-5.69a59.23,59.23,0,0,0,2,10.77c2.77.93,5.07,1.57,6.48,2.06a23.79,23.79,0,0,1,9.5,6.49,29.85,29.85,0,0,0,6.46-8.37c-1.77-1.52-4.56-3.79-8.44-6.53-7.28-5.13-4.75-11.62,1-7.59,4.17,2.91,7.4,8.31,8.86,11.08a45.08,45.08,0,0,0,3.3-15.16c-5.72-5.36-19.85-12.84-15.59-12.84,3.83,0,12.41,5.62,15.56,7.79a38.46,38.46,0,0,0-.48-4.4c-5.39-3.53-22.88-9-20.09-10.6,3.06-1.73,15.26,3.92,19,5.71a22.24,22.24,0,0,0-3.24-6.7c-7.44-10-20.85-13.39-26.7-11.49-4.14,1.34-2.93,11.85-3.82,11.49C650.5,258,642.94,262.7,649.05,283.11ZM689.83,282c1.18-1.42,6.64,2.77,5.06,5.07S688.31,283.78,689.83,282Zm-28.52-9c1.43.92-.69,6.22-2.91,4.62C656.52,276.24,659.86,272.07,661.31,273Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.48,274.62c.76-1.48,1.54-3,2.39-4.39a26.08,26.08,0,0,1,2.75-4c-.23-.29-.46-.59-.71-.88a.12.12,0,0,1,.18-.16l.81,1a.28.28,0,0,1,.12.14c1,1.23,2,2.5,2.92,3.79a45.16,45.16,0,0,1,4.83,1.4c1.63.55,3.25,1.12,4.83,1.79.17.07.09.34-.08.27-1.57-.7-3.16-1.37-4.79-1.92s-3.11-.92-4.67-1.36c.51.71,1,1.44,1.48,2.17a57.17,57.17,0,0,1,8.55,3.48c2.88,1.38,5.66,3,8.43,4.57.16.09,0,.33-.15.24-2.71-1.62-5.53-3-8.38-4.34-2.68-1.25-5.45-2.28-8.15-3.48,6.79,10.61,10.87,22.84,16.32,34.17.08.16-.18.3-.25.13-1.66-4-3.58-7.84-5.39-11.75-1.63-3.51-3.21-7-4.84-10.54-.48-1-1-2.05-1.46-3.07.29,5.66.17,11.42,1.1,17a.14.14,0,1,1-.28,0c-.39-6.05-1.46-12-1.41-18.1a.15.15,0,0,1,0-.07c-1.15-2.32-2.38-4.6-3.71-6.82-2.25,5.3-4.61,10.68-5.66,16.37,0,.17-.32.09-.27-.08,1.53-5.71,2.94-11.42,5.69-16.69a64.2,64.2,0,0,0-4.78-6.9c-.76,1.41-1.73,2.74-2.58,4.09s-1.66,2.64-2.44,4a58,58,0,0,0-4.25,9c-.06.17-.34.08-.27-.08C660.69,280.58,662,277.55,663.48,274.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.93,287.51c4.36-4.37,9.43-10.11,16.17-10.1,6.5,0,11.29,5.25,14,10.65,2.88,5.65,3.91,12.05,4.72,18.27a219,219,0,0,1,1.73,22.45c.12,4.17.1,8.35,0,12.52a83.3,83.3,0,0,1-1,12.62c-.12.68-1.2.7-1.24,0-.2-3.51,0-7,0-10.55s0-6.92-.16-10.38c-.25-7-.76-14-1.59-20.93-.71-6.08-1.28-12.32-3.1-18.19-1.64-5.29-4.71-11.34-10.08-13.67-7.32-3.17-14.47,2.63-19.26,7.52C610,287.82,609.81,287.64,609.93,287.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.69,297.28h0c0,.89.09,1.78.15,2.64a15.82,15.82,0,0,1,7.14-3c6.19-.66,5.79,4,1.66,4.24a23.4,23.4,0,0,0-8.49,1.71c1,8.17,3.26,14.73,3.59,14.82a119,119,0,0,0,16.35-2.06c-1.53-3.28-5-7.64-3.25-8s3.73,3.53,4.72,7.69a79,79,0,0,0,11.89-3.27c-2.72-2.36-6.92-5.29-5.32-6.54s5,2.88,7,5.88a23.86,23.86,0,0,0,5.14-2.87c-3.67-5.38-12.6-6.48-11.44-10.37s9.53,1.5,13.28,8.71c4.41-4.57,5.7-11,5.24-16.57-3.84-.45-11.23.36-10.69-2.39s5.87-2.24,10.24-.63a15.44,15.44,0,0,0-2.56-6.07c-4-5.2-16.4,1.41-16.4,1.41s1.32-12.42-3.39-14.56c-2.72-1.24-7.51-1.23-12.32,1.6,2.7.23,6,1.08,7.27,3,1.67,2.39-1,3.69-2.65,2.59-1.18-.79-3.39-3.24-7.38-3.57a24.64,24.64,0,0,0-4.46,4.94c-.45.64-.88,1.32-1.3,2.05a17,17,0,0,1,14.46.26c5.35,2.66,2.36,8.22-2.24,6.06s-9-4.28-13.88-3.06a34.47,34.47,0,0,0-2.35,13.85,24.21,24.21,0,0,1,7.93-3.81c5.32-1.4,6.93,1.78,1.09,2.38A23.21,23.21,0,0,0,587.69,297.28Zm6.48-8.55c-.37-1.72,3.41-2.22,4-.82C598.73,289.11,594.53,290.46,594.17,288.73Zm32.3,9.56c.36-1,2.88.12,2.65,1.3C628.81,301.15,626.13,299.23,626.47,298.29Zm-17.83,6c1.84-.74,4.71,3.84,2.71,4.89S607.13,304.94,608.64,304.34Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.47,316.8c2.77-4.64,5.51-9.3,8.43-13.86q2-3.18,4.25-6.24c-.22,0-.45-.11-.66-.15l-1.11-.21c-.85-.15-1.71-.28-2.57-.36s-1.62-.13-2.43-.14a12,12,0,0,0-2.61.14c-.1,0-.12-.14,0-.14.87,0,1.76-.08,2.62-.09s1.69,0,2.53.06,1.58.12,2.36.24l1.3.23a7.82,7.82,0,0,1,.78.17q2.25-3.1,4.67-6.08a55.65,55.65,0,0,0-15.19-4.85c-.09,0-.05-.15,0-.13a51.15,51.15,0,0,1,15.4,4.67c.89-1.09,1.78-2.17,2.68-3.25s2.08-2.39,3-3.67c.06-.08.18,0,.11.08a54.17,54.17,0,0,0-3.52,4.31h0a53.62,53.62,0,0,1,5.65,4.53q2.77,2.46,5.4,5.07c.06.06,0,.16-.1.1-1.73-1.72-3.52-3.36-5.4-4.92s-3.85-3-5.73-4.53l0,0-1.29,1.7-.65.85a.18.18,0,0,1,0,.07c-.72.93-1.44,1.88-2.15,2.82a22.43,22.43,0,0,1,2.14,3.87c.62,1.31,1.16,2.66,1.66,4a59.34,59.34,0,0,1,2.32,8.7c0,.08-.12.12-.14,0a50.61,50.61,0,0,0-2.52-8.53c-.54-1.41-1.16-2.8-1.79-4.18s-1.28-2.46-1.81-3.73c-.63.83-1.25,1.66-1.86,2.5-.17.24-.34.49-.52.73,0,.06,0,.13-.06.13h0c-1.9,2.66-3.72,5.39-5.48,8.14a2.5,2.5,0,0,1,.24.61c.11.33.22.67.32,1a18.61,18.61,0,0,1,.48,2.06c.12.66.21,1.32.28,2a16.64,16.64,0,0,0,.17,2.24c0,.11-.16.12-.14,0a7.42,7.42,0,0,0-.15-2.1c-.11-.72-.24-1.43-.4-2.13s-.32-1.27-.51-1.9c-.1-.32-.2-.63-.31-.94s-.14-.34-.19-.51q-1.24,1.93-2.45,3.9c-1.6,2.6-3.18,5.2-4.77,7.8C592.6,317.05,592.39,316.93,592.47,316.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.26,352.42c.07-2.63.48-5.27.77-7.89s.58-5.25.86-7.88c.54-5.06.84-10.23,2-15.2a22.15,22.15,0,0,1,6.19-11.37,10.08,10.08,0,0,1,6.06-2.89,10.48,10.48,0,0,1,6.44,2,22.31,22.31,0,0,1,5.42,5.71,55.36,55.36,0,0,1,4.22,6.86c0,.09-.09.14-.14.06A35.11,35.11,0,0,0,658,311.56a10.83,10.83,0,0,0-5.76-2.4,7.82,7.82,0,0,0-5.58,2.23c-3.07,2.66-4.84,6.59-5.9,10.43-1.25,4.57-1.66,9.37-2.28,14.05-.37,2.78-.73,5.56-1.1,8.34s-.59,5.61-1.18,8.34A.46.46,0,0,1,635.26,352.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.19,332a14.58,14.58,0,0,0,2.86,2.92c-.43-2.57-1-7.13.34-9.55,2-3.77,4.39-1.89,3.19,1.38a26.79,26.79,0,0,0-1.94,9.29,40,40,0,0,0,8.74,4.12,14.53,14.53,0,0,1-.29-4.49c.4-4,3.49-4,2.69.24a25.31,25.31,0,0,0-.43,4.92A90.38,90.38,0,0,0,677,343.91a39.88,39.88,0,0,0,5.64-10c-3.28-.82-9.92-1-9.78-3.35.19-3.16,6.62-.73,10.38,1.56a25.13,25.13,0,0,0,1.14-8.48,41.79,41.79,0,0,0-9.05-1.5c-6.75-.59-6.42-4.42-1.52-4.33,3.61.07,8.17,2.28,10.34,3.43-1.41-9.19-8.42-15.07-14-15.3-9.44-.38-6,11.37-6,11.37s-6.4-4.5-12.44-4.38S641.73,323,648.19,332Zm25.22-17c-.21-1.33,4-1.64,4.23.05C677.89,317,673.63,316.36,673.41,315Zm6.79,13.78c-.09-.86,1.73-1,2.14.08C682.62,329.59,680.27,329.66,680.2,328.8Zm-22.68.81c1.42.2,2.23,5.29-.22,5.19C655.43,334.72,656.31,329.44,657.52,329.61Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.49,335.26c.23-.63.44-1.28.64-1.92-.18.65-.35,1.31-.47,2A.09.09,0,1,1,659.49,335.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662,327.08c.44-1.3.94-2.59,1.45-3.87.27-.69.55-1.37.85-2a8.15,8.15,0,0,1,.84-1.7,12.22,12.22,0,0,1-.76-1.65c0-.05,0-.1.08-.05a19.8,19.8,0,0,1,1.84,2.85l.77,1.35a12.23,12.23,0,0,1,1.59.25c.57.1,1.13.21,1.69.34L672,323c.55.14,1.11.32,1.67.41a.09.09,0,1,1-.05.17,12,12,0,0,0-1.76-.46c-.55-.12-1.09-.21-1.64-.29s-1.1-.15-1.65-.2l-1.25-.1c.23.39.46.78.68,1.18a1.86,1.86,0,0,0,.1.2,5.27,5.27,0,0,1,1.36.16c.48.08,1,.18,1.45.28,1,.22,2,.45,2.94.72,2,.58,4.07,1.23,6.08,1.89.11,0,0,.2-.07.17a58.66,58.66,0,0,0-6.1-1.7c-1-.22-1.94-.44-2.91-.64l-1.45-.31a8.41,8.41,0,0,1-1.13-.25c1,1.92,2,3.87,2.92,5.86,2,4.34,3.61,8.8,5.29,13.25,0,.11-.13.18-.17.07a122.67,122.67,0,0,0-5.63-12.95c-.38-.77-.77-1.53-1.15-2.3,0,.16-.07.31-.1.47-.09.53-.19,1.05-.28,1.58-.17,1-.35,2.11-.51,3.16a37.38,37.38,0,0,0-.76,6.57c0,.13-.2.13-.18,0a31.09,31.09,0,0,0,.23-3.2c.07-1.11.15-2.21.28-3.31s.26-2.12.44-3.18c.08-.52.18-1.05.27-1.57a3.15,3.15,0,0,1,.3-1.15c-.55-1.11-1.1-2.22-1.66-3.32s-1.06-2.08-1.6-3.11l-.72-1.32a11.38,11.38,0,0,1-.62,1.59c-.24.6-.49,1.19-.73,1.79-.54,1.32-1,2.65-1.55,4-.71,1.89-1.5,3.82-2.09,5.79C660.85,331,661.33,329,662,327.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.13,333.34c0-.16.09-.31.14-.46C660.22,333,660.18,333.19,660.13,333.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "619.46 347.31 620.13 361.37 621.84 397.61 659.22 397.61 660.93 361.37 661.6 347.31 619.46 347.31",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "619.46 347.31 620.13 361.37 660.93 361.37 661.6 347.31 619.46 347.31",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.81,
    y: 341.63,
    width: 47.45,
    height: 11.37,
    transform: "translate(1281.06 694.62) rotate(180)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 649.63,
    y: 397.61,
    width: 6.56,
    height: 5.95,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 649.63,
    y: 397.61,
    width: 6.56,
    height: 2.98,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 624.86,
    y: 397.61,
    width: 6.56,
    height: 5.95,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 624.86,
    y: 397.61,
    width: 6.56,
    height: 2.98,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-87"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "46.93 403.56 128.95 403.31 210.96 403.23 375 403.06 539.04 403.23 621.05 403.31 703.07 403.56 621.05 403.8 539.04 403.89 375 404.06 210.96 403.89 128.95 403.8 46.93 403.56",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-87"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 149.9,
    y: 79.52,
    width: 450.2,
    height: 306.13,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.9,
    y: 340.5,
    width: 450.2,
    height: 45.16,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.27,
    y: 440.84,
    width: 175.46,
    height: 14.66,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "441.83 440.85 308.16 440.85 311.56 415.4 311.73 414.2 312.04 411.81 312.2 410.62 312.52 408.23 312.57 407.86 312.68 407.03 313.01 404.64 313.16 403.44 315.54 385.66 434.46 385.66 436.7 402.43 436.81 403.24 437.18 406.02 437.28 406.83 437.43 407.86 437.66 409.61 437.76 410.41 438.13 413.2 438.25 414 441.83 440.85",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.33,360a7.46,7.46,0,1,1-7.46-7.46A7.46,7.46,0,0,1,382.33,360Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.43 407.86 313.16 403.44 315.54 385.66 434.46 385.66 437.43 407.86",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.67,
    y: 99.43,
    width: 408.65,
    height: 219.83,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.67,
    y: 99.43,
    width: 409.01,
    height: 219.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.67,
    y: 107.89,
    width: 402.85,
    height: 53.13,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.67,
    y: 99.43,
    width: 409.01,
    height: 8.46,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.4,103.66a2.1,2.1,0,1,1-2.1-2.1A2.09,2.09,0,0,1,177.4,103.66Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,103.66a2.1,2.1,0,1,1-2.1-2.1A2.09,2.09,0,0,1,186,103.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.53,103.66a2.1,2.1,0,1,1-2.1-2.1A2.09,2.09,0,0,1,194.53,103.66Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 573.52,
    y: 107.89,
    width: 6.16,
    height: 211.35,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.6,181.16h0a1.59,1.59,0,0,1-1.59-1.59V110.71a1.59,1.59,0,0,1,1.59-1.59h0a1.59,1.59,0,0,1,1.59,1.59v68.86A1.59,1.59,0,0,1,576.6,181.16Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473.54,
    y: 118.2,
    width: 82.97,
    height: 11.07,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.63,129.38h-83.2v-11.3h83.2Zm-83-.22H556.4V118.31H473.66Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 545.33,
    y: 118.08,
    width: 11.31,
    height: 11.31,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.49,126.84l-1,.77-1.9-2.5-.69-.91a1.54,1.54,0,0,0,.39-.23,1.66,1.66,0,0,0,.53-.68l.74,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.47,121a2.78,2.78,0,0,0-3.91-.52,2.79,2.79,0,0,0,3.4,4.43,3,3,0,0,0,.58-.6A2.78,2.78,0,0,0,552.47,121Zm-1.2,3a1.54,1.54,0,0,1-.39.23,1.67,1.67,0,1,1,.92-.91A1.66,1.66,0,0,1,551.27,124Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.86,
    y: 120.37,
    width: 0.59,
    height: 6.72,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.94,
    y: 118.2,
    width: 242.96,
    height: 11.07,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459,129.38H215.82v-11.3H459Zm-243-.22H458.79V118.31H216.05Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.25,
    y: 120.37,
    width: 0.59,
    height: 6.72,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.04 127.52 191 123.81 195.03 119.95 195.66 120.6 192.32 123.8 195.65 126.86 195.04 127.52",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.77 119.94 208.8 123.66 204.78 127.52 204.15 126.87 207.49 123.67 204.16 120.61 204.77 119.94",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.65,
    y: 252.42,
    width: 61.95,
    height: 47.53,
    transform: "translate(709.25 552.37) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.81,262.82a5.63,5.63,0,1,0,4.42-4.42A5.64,5.64,0,0,0,329.81,262.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.08 289.71 385.6 289.71 364.84 264.13 344.08 289.71",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.65 289.71 360.46 289.71 342.05 273.05 323.65 289.71",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.65,
    y: 289.71,
    width: 61.95,
    height: 10.24,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.45,
    y: 175.57,
    width: 87.88,
    height: 67.43,
    transform: "translate(464.78 418.57) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.2,190.31a8,8,0,1,0,6.26-6.26A8,8,0,0,0,197.2,190.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.44 228.47 276.33 228.47 246.89 192.18 217.44 228.47",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.45 228.47 240.67 228.47 214.56 204.84 188.45 228.47",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.45,
    y: 228.47,
    width: 87.88,
    height: 14.53,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.85,
    y: 252.42,
    width: 46.53,
    height: 3.92,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.85,
    y: 261.51,
    width: 124.66,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.85,
    y: 270.12,
    width: 124.66,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.85,
    y: 278.73,
    width: 124.66,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.85,
    y: 287.35,
    width: 124.66,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.85,
    y: 295.96,
    width: 124.66,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.6,
    y: 175.57,
    width: 48.53,
    height: 3.92,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.6,
    y: 184.65,
    width: 70.66,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.6,
    y: 193.27,
    width: 70.66,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.6,
    y: 201.88,
    width: 70.66,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.6,
    y: 210.49,
    width: 70.66,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.6,
    y: 227.72,
    width: 70.66,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.6,
    y: 236.33,
    width: 70.66,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.6,
    y: 244.95,
    width: 70.66,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.6,
    y: 253.56,
    width: 70.66,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.6,
    y: 270.79,
    width: 70.66,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.6,
    y: 279.4,
    width: 70.66,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.6,
    y: 288.01,
    width: 70.66,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.6,
    y: 296.63,
    width: 70.66,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.97,
    y: 184.65,
    width: 70.66,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.97,
    y: 193.27,
    width: 70.66,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.97,
    y: 176.04,
    width: 70.66,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.97,
    y: 201.88,
    width: 70.66,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.97,
    y: 210.49,
    width: 70.66,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.97,
    y: 219.11,
    width: 70.66,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.97,
    y: 227.72,
    width: 70.66,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.97,
    y: 244.95,
    width: 70.66,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.97,
    y: 253.56,
    width: 70.66,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.97,
    y: 262.17,
    width: 70.66,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.97,
    y: 270.79,
    width: 70.66,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.97,
    y: 279.4,
    width: 70.66,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 175.57,
    width: 46.53,
    height: 10.47,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 193.27,
    width: 95.6,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 201.88,
    width: 95.6,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 210.49,
    width: 95.6,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 219.11,
    width: 95.6,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 230.56,
    width: 95.6,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 239.18,
    width: 95.6,
    height: 3.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.67,
    y: 99.43,
    width: 409.01,
    height: 219.8,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shield--inject-87"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M656.94,156s-8.3,66.48-22,81.43c-16.38,18-28.27,15.33-34.88,24.58h0c-6.62-9.26-18.51-6.63-34.9-24.59C551.55,222.46,543.26,156,543.26,156c36-17.46,56.84-37,56.84-37h0C600.75,119.57,621.54,138.8,656.94,156Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.11,119V262h0c-6.62-9.26-18.51-6.63-34.9-24.59C551.55,222.46,543.26,156,543.26,156c36-17.46,56.84-37,56.84-37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.12,161.33s-7,56.16-18.54,68.8c-13.85,15.18-23.9,13-29.48,20.77-5.59-7.82-15.64-5.59-29.49-20.77-11.53-12.64-18.53-68.8-18.53-68.8,30.38-14.75,48-31.27,48-31.27S617.75,146.58,648.12,161.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.1,161.34s7,56.15,18.54,68.79c13.84,15.17,23.87,13,29.47,20.75V130.08C599.57,130.58,582,146.81,552.1,161.34Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600.1,
    cy: 190.48,
    r: 22.27,
    transform: "translate(62.61 518.37) rotate(-48.99)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "597.56 204.95 587.65 194.63 591.33 191.1 596.79 196.78 608.58 178.7 612.86 181.49 597.56 204.95",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--safe-box--inject-87"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.91,
    y: 299.08,
    width: 156.06,
    height: 148.37,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.56,
    y: 309.28,
    width: 136.76,
    height: 127.98,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.32 437.26 240.72 416.68 240.72 309.28 259.32 309.28 259.32 437.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.32 437.26 122.56 437.26 122.56 416.68 240.72 416.68 259.32 437.26",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.47 455.5 130.39 455.5 128.25 447.45 155.6 447.45 153.47 455.5",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.26 447.46 155.6 447.46 154.6 451.26 129.31 451.43 128.26 447.46",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.49 455.5 228.41 455.5 226.28 447.45 253.63 447.45 251.49 455.5",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.63 447.46 252.79 450.61 227.16 450.78 226.28 447.46 253.63 447.46",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.05,
    y: 363.1,
    width: 99.27,
    height: 72.11,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.42 355.63 263.27 355.63 263.28 363.1 224.31 363.1 226.42 355.63",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 164.05,
    y: 363.1,
    width: 99.27,
    height: 72.11
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "226.42 355.63 263.27 355.63 263.28 363.1 224.31 363.1 226.42 355.63"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 177.21,
    y: 323.75,
    width: 70.7,
    height: 92.24,
    transform: "translate(32.08 -16.67) rotate(4.86)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.87,418.82l-70.44-6h0v0l7.77-91.91v-.06h.06l70.44,6h0v0Zm0,0,7.78-91.91,0,0-70.44-6,.06-.05-7.84,91.9,0,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.4,
    y: 413.63,
    width: 70.7,
    height: 2.2,
    transform: "translate(35.86 -16.18) rotate(4.86)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.65,
    y: 323.47,
    width: 5.12,
    height: 45.21,
    transform: "translate(29.96 -14.35) rotate(4.86)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.35,
    y: 371.09,
    width: 5.12,
    height: 45.21,
    transform: "translate(34.2 -18.98) rotate(4.86)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.02,
    y: 323.91,
    width: 70.7,
    height: 2.2,
    transform: "translate(28.29 -17.15) rotate(4.86)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.1,
    y: 340.67,
    width: 25.7,
    height: 25.7,
    transform: "translate(30.7 -16.84) rotate(4.86)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.37,350.5a5.15,5.15,0,1,1-4.69-5.57A5.15,5.15,0,0,1,219.37,350.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.91,365l-.18,2.09L204,365.56l.18-2.08a8.9,8.9,0,1,1,17.74,1.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.35,
    y: 329.71,
    width: 60.64,
    height: 7.12,
    transform: "translate(28.99 -17.06) rotate(4.86)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.77,
    y: 338.64,
    width: 11.83,
    height: 0.8,
    transform: "translate(29.39 -14.93) rotate(4.86)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.22,
    y: 368.69,
    width: 11.83,
    height: 0.8,
    transform: "matrix(1, 0.08, -0.08, 1, 31.93, -14.6)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.51,
    y: 400.58,
    width: 11.83,
    height: 0.8,
    transform: "translate(34.61 -14.26) rotate(4.86)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.6,
    y: 387.71,
    width: 11.83,
    height: 0.8,
    transform: "translate(33.53 -14.4) rotate(4.86)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.06,
    y: 342.49,
    width: 11.83,
    height: 0.8,
    transform: "translate(29.87 -18.75) rotate(4.86)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.59,340.88c1.26.07,2.53.16,3.79.25l3.78.3,3.78.35c1.26.12,2.52.24,3.78.38-1.27-.07-2.53-.16-3.79-.25l-3.78-.3-3.78-.34Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.5,342c1.26.07,2.52.16,3.79.25l3.78.3,3.78.34,3.78.39c-1.27-.07-2.53-.16-3.79-.25l-3.79-.3-3.78-.34C187,342.24,185.76,342.11,184.5,342Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.41,343.06c1.26.07,2.52.16,3.78.25l3.79.3,3.78.34c1.26.13,2.52.25,3.77.39-1.26-.07-2.52-.16-3.78-.25l-3.79-.3-3.78-.34C186.92,343.33,185.66,343.2,184.41,343.06Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.31,344.15c1.27.07,2.53.16,3.79.25l3.78.3,3.78.34,3.78.39c-1.26-.07-2.53-.16-3.79-.25l-3.78-.3-3.78-.34C186.83,344.41,185.57,344.29,184.31,344.15Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.22,345.24c.63,0,1.27.05,1.9.09l1.89.14,1.89.18c.63.07,1.26.14,1.88.23l-1.89-.09-1.9-.14-1.88-.19C185.48,345.4,184.85,345.33,184.22,345.24Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,347.41l3.78.26,3.79.3,3.78.34c1.26.12,2.52.25,3.77.39-1.26-.07-2.52-.16-3.78-.25l-3.79-.3-3.78-.35C186.55,347.68,185.29,347.56,184,347.41Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.94,348.5c1.27.07,2.53.16,3.79.26l3.78.3,3.78.34q1.89.18,3.78.39c-1.26-.07-2.53-.16-3.79-.25l-3.78-.31-3.78-.34C186.46,348.77,185.2,348.65,183.94,348.5Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.85,349.59c1.26.07,2.53.16,3.79.26l3.78.3,3.78.34c1.26.12,2.52.24,3.78.39-1.27-.07-2.53-.16-3.79-.26l-3.78-.3-3.78-.34C186.37,349.86,185.11,349.74,183.85,349.59Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.76,350.68c1.26.07,2.52.16,3.79.26l3.78.3,3.78.34c1.26.12,2.52.24,3.78.39-1.27-.07-2.53-.16-3.79-.26l-3.79-.3-3.78-.34C186.27,351,185,350.83,183.76,350.68Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.67,351.77l1.89.09,1.89.14,1.89.19c.63.06,1.26.13,1.89.22-.63,0-1.27-.05-1.9-.09l-1.89-.14-1.89-.18C184.92,351.93,184.29,351.86,183.67,351.77Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.48,354c1.26.07,2.53.16,3.79.25l3.78.3,3.78.35c1.26.12,2.52.24,3.78.38-1.27-.07-2.53-.16-3.79-.25l-3.78-.3-3.78-.34Q185.37,354.16,183.48,354Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.39,355c1.26.07,2.52.16,3.79.25l3.78.3,3.78.34,3.78.39c-1.27-.07-2.53-.16-3.79-.25l-3.79-.3-3.78-.34C185.9,355.31,184.65,355.18,183.39,355Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.3,356.13c1.26.07,2.52.16,3.78.25l3.79.3,3.78.34c1.26.12,2.51.25,3.77.39-1.26-.07-2.52-.16-3.79-.25l-3.78-.3-3.78-.34C185.81,356.4,184.55,356.27,183.3,356.13Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.2,357.22c.64,0,1.27,0,1.9.09l1.89.14,1.89.18c.63.07,1.26.14,1.89.23-.64,0-1.27-.05-1.9-.09l-1.89-.14-1.89-.19C184.46,357.38,183.83,357.31,183.2,357.22Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,359.4c1.26.07,2.52.16,3.79.25l3.78.3,3.78.34c1.26.12,2.52.25,3.77.39-1.26-.07-2.52-.16-3.78-.25l-3.79-.3-3.78-.35C185.53,359.66,184.28,359.54,183,359.4Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.93,360.48c1.26.07,2.52.16,3.78.26l3.79.3,3.78.34c1.26.12,2.51.25,3.77.39-1.26-.07-2.52-.16-3.79-.25l-3.78-.3-3.78-.35C185.44,360.75,184.18,360.63,182.93,360.48Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.83,361.57c1.27.07,2.53.16,3.79.26l3.78.3,3.78.34c1.26.12,2.52.24,3.78.39-1.26-.07-2.53-.16-3.79-.25l-3.78-.31-3.78-.34C185.35,361.84,184.09,361.72,182.83,361.57Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.74,362.66c1.26.07,2.53.16,3.79.26l3.78.3,3.78.34c1.26.12,2.52.24,3.78.39-1.27-.07-2.53-.16-3.79-.26l-3.78-.3-3.78-.34C185.26,362.93,184,362.81,182.74,362.66Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.65,363.75l1.89.09,1.9.14,1.89.19c.62.06,1.25.13,1.88.22-.63,0-1.26-.05-1.9-.09l-1.89-.14-1.89-.18C183.9,363.91,183.27,363.84,182.65,363.75Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.89,344.73c1.26.07,2.52.16,3.78.25l3.79.3,3.78.34c1.26.13,2.52.25,3.77.39-1.26-.07-2.52-.16-3.78-.25l-3.79-.3-3.78-.34C232.4,345,231.14,344.87,229.89,344.73Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.79,345.82c1.27.07,2.53.16,3.79.25l3.79.3,3.78.34,3.77.39c-1.26-.07-2.52-.16-3.79-.25l-3.78-.3-3.78-.34Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.7,346.91c1.27.07,2.53.16,3.79.25l3.78.3,3.78.34,3.78.39c-1.27-.07-2.53-.16-3.79-.25l-3.78-.3-3.78-.34Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.61,348c1.26.07,2.52.16,3.79.25l3.78.3,3.78.34,3.78.39c-1.27-.07-2.53-.16-3.79-.25l-3.79-.3-3.77-.35C232.13,348.26,230.87,348.14,229.61,348Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.52,349.08c.63,0,1.26.06,1.89.1l1.9.14c.63.06,1.26.11,1.88.18s1.26.14,1.89.23c-.63,0-1.27-.06-1.9-.1s-1.26-.09-1.89-.14l-1.89-.18C230.77,349.25,230.14,349.17,229.52,349.08Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.33,351.26c1.26.07,2.53.16,3.79.26l3.78.3,3.78.34c1.26.12,2.52.24,3.78.39-1.27-.07-2.53-.16-3.79-.25l-3.78-.31-3.78-.34C231.85,351.53,230.59,351.41,229.33,351.26Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.24,352.35c1.26.07,2.52.16,3.79.26l3.78.3,3.78.34c1.26.12,2.52.24,3.78.39-1.27-.07-2.53-.16-3.79-.26l-3.79-.3-3.78-.34C231.76,352.62,230.5,352.5,229.24,352.35Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.15,353.44c1.26.07,2.52.16,3.78.26l3.79.3,3.78.34c1.26.12,2.52.24,3.77.39-1.26-.07-2.52-.16-3.78-.26l-3.79-.3-3.78-.34C231.66,353.71,230.4,353.58,229.15,353.44Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.05,354.53c1.27.07,2.53.16,3.79.25l3.78.3,3.78.35c1.26.12,2.52.24,3.78.39-1.26-.07-2.52-.16-3.79-.26l-3.78-.3-3.78-.34Q230.94,354.74,229.05,354.53Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,355.62c.63,0,1.27.05,1.9.09l1.89.14,1.89.18c.63.07,1.26.14,1.88.23-.63,0-1.26-.05-1.89-.09l-1.89-.14-1.89-.18C230.22,355.78,229.59,355.71,229,355.62Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.78,357.8c1.26.07,2.52.16,3.78.25l3.79.3,3.78.34c1.26.13,2.52.25,3.77.39-1.26-.07-2.52-.16-3.78-.25l-3.79-.3-3.78-.34C231.29,358.07,230,357.94,228.78,357.8Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.68,358.89c1.27.07,2.53.16,3.79.25l3.78.3,3.78.34q1.89.18,3.78.39c-1.26-.07-2.53-.16-3.79-.25l-3.78-.3-3.78-.34Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.59,360c1.26.07,2.53.16,3.79.25l3.78.3,3.78.34,3.78.39c-1.27-.07-2.53-.16-3.79-.25l-3.78-.3-3.78-.34Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.5,361.07c.63,0,1.26.05,1.9.09l1.89.14,1.89.18c.63.07,1.25.14,1.88.23l-1.89-.09c-.64,0-1.27-.1-1.9-.15l-1.89-.18C229.75,361.23,229.13,361.16,228.5,361.07Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.31,363.24c1.27.07,2.53.16,3.79.26l3.78.3,3.78.34,3.78.39c-1.26-.07-2.53-.16-3.79-.25l-3.78-.31-3.78-.34C230.83,363.51,229.57,363.39,228.31,363.24Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.22,364.33c1.26.07,2.53.16,3.79.26l3.78.3,3.78.34c1.26.12,2.52.24,3.78.39-1.27-.07-2.53-.16-3.79-.26l-3.78-.3-3.78-.34C230.74,364.6,229.48,364.48,228.22,364.33Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.13,365.42c1.26.07,2.52.16,3.79.26l3.78.3,3.78.34c1.26.12,2.52.24,3.78.39-1.27-.07-2.53-.16-3.79-.26l-3.79-.3-3.78-.34C230.64,365.69,229.39,365.57,228.13,365.42Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,366.51c1.26.07,2.52.16,3.78.25l3.79.31,3.78.34c1.26.12,2.52.24,3.77.39-1.26-.07-2.52-.16-3.78-.26l-3.79-.3-3.78-.34C230.55,366.78,229.29,366.65,228,366.51Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.94,367.6c.64,0,1.27,0,1.9.09l1.89.14,1.89.18c.63.07,1.26.14,1.89.23-.64,0-1.27-.05-1.9-.09l-1.89-.14-1.89-.18C229.2,367.76,228.57,367.69,227.94,367.6Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.4,
    y: 372.97,
    width: 23.81,
    height: 1.11,
    transform: "translate(32.33 -15.36) rotate(4.86)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.41,
    y: 372.69,
    width: 17.22,
    height: 1.11,
    transform: "translate(32.3 -15.09) rotate(4.86)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.16,
    y: 375.82,
    width: 23.81,
    height: 1.11,
    transform: "translate(32.57 -15.33) rotate(4.86)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.16,
    y: 375.74,
    width: 21.84,
    height: 1.11,
    transform: "translate(32.56 -15.25) rotate(4.86)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.92,
    y: 378.67,
    width: 23.81,
    height: 1.11,
    transform: "translate(32.81 -15.3) rotate(4.86)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.93,
    y: 378.45,
    width: 18.56,
    height: 1.11,
    transform: "translate(32.79 -15.08) rotate(4.86)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.67,
    y: 381.52,
    width: 23.81,
    height: 1.11,
    transform: "translate(33.05 -15.27) rotate(4.86)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.68,
    y: 381.38,
    width: 20.47,
    height: 1.11,
    transform: "translate(33.03 -15.13) rotate(4.86)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.43,
    y: 384.37,
    width: 23.81,
    height: 1.11,
    transform: "translate(33.29 -15.24) rotate(4.86)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.43,
    y: 384.31,
    width: 22.4,
    height: 1.11,
    transform: "translate(33.29 -15.18) rotate(4.86)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.92,
    y: 371.4,
    width: 1.79,
    height: 1.79,
    transform: "translate(32.18 -14.14) rotate(4.86)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.68,
    y: 374.25,
    width: 1.79,
    height: 1.79,
    transform: "translate(32.42 -14.11) rotate(4.86)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.44,
    y: 377.1,
    width: 1.79,
    height: 1.79,
    transform: "translate(32.66 -14.08) rotate(4.86)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.2,
    y: 379.95,
    width: 1.79,
    height: 1.79,
    transform: "translate(32.9 -14.05) rotate(4.86)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.96,
    y: 382.8,
    width: 1.79,
    height: 1.79,
    transform: "translate(33.14 -14.02) rotate(4.86)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.86,
    y: 371.69,
    width: 15.17,
    height: 0.8,
    transform: "translate(32.31 -17.58) rotate(4.86)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.61,
    y: 374.39,
    width: 5.77,
    height: 0.8,
    transform: "translate(32.52 -17.15) rotate(4.86)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.04,
    y: 381.17,
    width: 5.77,
    height: 0.8,
    transform: "translate(33.08 -17.08) rotate(4.86)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.46,
    y: 387.96,
    width: 5.77,
    height: 0.8,
    transform: "translate(33.66 -17.01) rotate(4.86)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.88,
    y: 394.75,
    width: 5.77,
    height: 0.8,
    transform: "translate(34.23 -16.93) rotate(4.86)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.23,375.53c1.27.07,2.53.16,3.79.25l3.78.3,3.78.34,3.78.39c-1.26-.07-2.53-.16-3.79-.25l-3.78-.3-3.78-.34Q229.12,375.74,227.23,375.53Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.14,376.62c1.26.07,2.53.16,3.79.25l3.78.3,3.78.34,3.78.39c-1.27-.07-2.53-.16-3.79-.25l-3.78-.3-3.78-.34Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.05,377.71c1.26.07,2.52.16,3.78.25l3.79.3,3.78.34c1.26.12,2.52.25,3.77.39-1.26-.07-2.52-.16-3.78-.25l-3.79-.3-3.78-.34C229.56,378,228.3,377.85,227.05,377.71Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,378.8c.54,0,1.07,0,1.61.06l1.6.12,1.59.15c.53.06,1.07.13,1.59.21-.53,0-1.07,0-1.6-.07l-1.6-.11-1.59-.16C228,378.94,227.48,378.88,227,378.8Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.65,382.33c1.27.07,2.53.16,3.79.26l3.78.3,3.78.34,3.78.39c-1.26-.07-2.52-.16-3.79-.25l-3.78-.31-3.78-.34C229.17,382.6,227.91,382.48,226.65,382.33Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.56,383.42c1.26.07,2.53.16,3.79.26l3.78.3,3.78.34c1.26.12,2.52.24,3.78.39-1.27-.07-2.53-.16-3.79-.25l-3.78-.31-3.78-.34C229.08,383.69,227.82,383.57,226.56,383.42Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.47,384.51c1.26.07,2.52.16,3.79.26l3.78.3,3.78.34c1.26.12,2.52.24,3.78.39-1.27-.07-2.53-.16-3.79-.26l-3.79-.3-3.78-.34C229,384.78,227.73,384.66,226.47,384.51Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.38,385.6c.53,0,1.07,0,1.6.07l1.6.11,1.59.16c.54.06,1.07.12,1.6.2-.54,0-1.07,0-1.61-.06l-1.6-.12L228,385.8C227.44,385.75,226.91,385.68,226.38,385.6Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.08,389.14c1.26.07,2.52.16,3.78.25l3.79.3,3.78.35c1.26.12,2.52.24,3.77.39l-3.78-.26-3.79-.3-3.78-.34C228.59,389.41,227.33,389.28,226.08,389.14Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,390.23c1.27.07,2.53.16,3.79.25l3.78.3,3.78.35c1.26.12,2.52.24,3.78.38-1.26-.07-2.53-.16-3.79-.25l-3.78-.3-3.78-.34Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.89,391.32c1.26.07,2.53.16,3.79.25l3.78.3,3.78.34c1.26.13,2.52.25,3.78.39-1.27-.07-2.53-.16-3.79-.25l-3.78-.3-3.78-.34Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.8,392.41c.53,0,1.07,0,1.6.07l1.6.11,1.6.16c.53.06,1.06.12,1.59.2-.54,0-1.07,0-1.61-.07l-1.59-.11-1.6-.16C226.86,392.55,226.33,392.49,225.8,392.41Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.5,396c1.26.07,2.52.16,3.78.25l3.79.3,3.78.34c1.26.12,2.52.25,3.77.39-1.26-.07-2.52-.16-3.78-.25l-3.79-.3-3.78-.35C228,396.21,226.75,396.09,225.5,396Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.4,397l3.79.26,3.79.3,3.78.34c1.26.12,2.51.25,3.77.39-1.26-.07-2.52-.16-3.79-.25l-3.78-.3-3.78-.35C227.92,397.3,226.66,397.18,225.4,397Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.31,398.12c1.27.07,2.53.16,3.79.26l3.78.3,3.78.34q1.89.18,3.78.39c-1.26-.07-2.53-.16-3.79-.25l-3.78-.31-3.78-.34C227.83,398.39,226.57,398.27,225.31,398.12Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.22,399.21c.54,0,1.07,0,1.6.07s1.07.08,1.6.12,1.07.09,1.6.15,1.06.12,1.59.21c-.54,0-1.07,0-1.6-.07s-1.07-.08-1.6-.12-1.07-.09-1.6-.15S225.75,399.29,225.22,399.21Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.22 375 223.98 378.44 223.71 381.88 223.15 388.75 223.09 389.18 222.77 392.61 222.44 396.04 222.68 392.6 222.95 389.16 222.96 388.74 223.57 381.87 223.89 378.43 224.22 375",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.56,375.3a.37.37,0,0,1-.39.33.36.36,0,0,1-.32-.39.34.34,0,0,1,.38-.32A.36.36,0,0,1,224.56,375.3Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,382.11a.36.36,0,0,1-.71-.06.36.36,0,1,1,.71.06Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.4,388.91a.36.36,0,0,1-.38.33.36.36,0,1,1,.06-.71A.35.35,0,0,1,223.4,388.91Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.82,395.72a.36.36,0,0,1-.71-.06.37.37,0,0,1,.39-.33A.36.36,0,0,1,222.82,395.72Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.43,393.19a2.63,2.63,0,1,1-.23-1.33A2.68,2.68,0,0,1,185.43,393.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.2,391.86,182.81,393l.22-2.63A2.65,2.65,0,0,1,185.2,391.86Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.62,393.12a1.82,1.82,0,1,1-3.63-.31,1.82,1.82,0,1,1,3.63.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.08,
    y: 392.56,
    width: 1.52,
    height: 0.21,
    transform: "matrix(1, 0.08, -0.08, 1, 33.91, -14.07)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.65,
    y: 393.16,
    width: 2.27,
    height: 0.21,
    transform: "translate(33.96 -14.07) rotate(4.86)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.78,393.81c0,.13,0,.26-.07.39a2.48,2.48,0,1,1,.07-.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.78,393.81c0,.13,0,.26-.07.39l-2.56-.61.22-2.62a2.62,2.62,0,0,1,2.17,1.51A2.59,2.59,0,0,1,192.78,393.81Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,393.74a1.82,1.82,0,1,1-3.63-.3,1.82,1.82,0,0,1,3.63.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.42,
    y: 393.19,
    width: 1.52,
    height: 0.21,
    transform: "translate(33.96 -14.68) rotate(4.85)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.99,
    y: 393.78,
    width: 2.27,
    height: 0.21,
    transform: "translate(34.02 -14.68) rotate(4.85)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.17,394.44a2.66,2.66,0,0,1-1.89,2.31,2.58,2.58,0,0,1-1,.09,2.63,2.63,0,1,1,2.61-3.73A2.59,2.59,0,0,1,200.17,394.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.17,394.44a2.66,2.66,0,0,1-1.89,2.31l-.74-2.53.23-2.63a2.64,2.64,0,0,1,2.16,1.52A2.59,2.59,0,0,1,200.17,394.44Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.36,394.37a1.82,1.82,0,1,1-1.66-2A1.82,1.82,0,0,1,199.36,394.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.81,
    y: 393.82,
    width: 1.52,
    height: 0.21,
    transform: "translate(34.04 -15.31) rotate(4.85)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.39,
    y: 394.41,
    width: 2.27,
    height: 0.21,
    transform: "translate(34.1 -15.3) rotate(4.85)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.52,395.07a2.64,2.64,0,0,1-2.85,2.4,2.57,2.57,0,0,1-1.64-.78,2.61,2.61,0,0,1-.76-2.07,2.64,2.64,0,0,1,5-.89A2.74,2.74,0,0,1,207.52,395.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.52,395.07a2.64,2.64,0,0,1-2.85,2.4,2.57,2.57,0,0,1-1.64-.78l1.87-1.85.22-2.62a2.66,2.66,0,0,1,2.17,1.51A2.74,2.74,0,0,1,207.52,395.07Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.71,395a1.82,1.82,0,1,1-1.66-2A1.82,1.82,0,0,1,206.71,395Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.16,
    y: 394.44,
    width: 1.52,
    height: 0.21,
    transform: "matrix(1, 0.08, -0.08, 1, 34.15, -15.94)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.74,
    y: 395.03,
    width: 2.27,
    height: 0.21,
    transform: "translate(34.19 -15.93) rotate(4.86)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.96 370.65 211.7 374.25 211.42 377.84 210.83 385.02 210.2 392.19 209.87 395.78 209.52 399.37 209.78 395.77 210.06 392.18 210.65 385 211.28 377.83 211.61 374.24 211.96 370.65",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--IaQ7Yo--inject-87"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.8,404.64a.22.22,0,0,1-.11.05h-.16l-.1,0a1.19,1.19,0,0,1-.35-.19,2.47,2.47,0,0,1-.59-.7,1,1,0,0,1-.12-.37.41.41,0,0,1,0-.11v-.09a.32.32,0,0,1,0-.09.35.35,0,0,1,0-.08h0l.37.45v0a.2.2,0,0,0,0,.2,4.47,4.47,0,0,0,.34.4.19.19,0,0,0,.2.06h0l.38.45Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.06,404.42l-.15.13h0l-.39-.45,0,0,.13-.11a.07.07,0,0,1,.11,0c.09.11.19.22.28.34A.06.06,0,0,1,181.06,404.42Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.09,403.26l-.17.14-.38-.44h0l.16-.14a.07.07,0,0,1,.1,0l.29.34S180.13,403.24,180.09,403.26Z",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--TEfYE6--inject-87"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.81,406.77l-.05,0-.76.61a.11.11,0,0,1-.16,0l-.65-.73,0,0a.07.07,0,0,1,.06,0l.49,0,1,.09A.15.15,0,0,1,180.81,406.77Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.7,408h-.06l-.58,0-.93-.08-.08,0,.63-.51.1.12,0,0a.13.13,0,0,0,.18,0l.17-.13.53.59Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.61,407.29l-.61.5v0c0-.34.06-.68.08-1a0,0,0,0,0,0,0Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.77,407.93l-.2-.22-.31-.35h0c.2-.17.41-.33.6-.5C180.86,406.87,180.78,407.9,180.77,407.93Z",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--aiZGp2--inject-87"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209,405.72a1.42,1.42,0,0,0-.12.4h0l-.35,0h0v0l0-.14a2,2,0,0,1,.1-.21h0l.33,0Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.88,406.62h0l-.32,0a0,0,0,0,1,0,0,1.14,1.14,0,0,1-.06-.25.62.62,0,0,1,0-.13h0l.35,0h0v.09s0,.09,0,.13l0,.17Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.25,406.85h0a.57.57,0,0,1-.11.11.81.81,0,0,1-.14.12l-.17.08-.17,0-.14,0h0a1,1,0,0,0,.28-.23,1.09,1.09,0,0,0,.13-.17h0l.33,0Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,406.22l-.46,0,0-.41h0l.36,0h0a1.05,1.05,0,0,1,.06.24v.17Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,406.32v0s0,0,0,.07a.29.29,0,0,1,0,.09.64.64,0,0,1-.08.19h0l-.37,0h0l0-.39Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.44,405.77l0,.4-.46,0v0s0,0,0-.07l0-.1a1.54,1.54,0,0,1,.08-.19h0l.34,0Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.4,406.28c0,.13,0,.25,0,.38h0l-.36,0h0a.8.8,0,0,1-.05-.21v-.11s0-.05,0-.07h0l.44,0Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.46,406.26l-.38,0a1.21,1.21,0,0,0-.05-.42h0l.34,0s0,0,0,0a1.11,1.11,0,0,1,.07.26v.14Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.45,406.36v0s0,.07,0,.1a.85.85,0,0,1-.09.22l0,0h0l-.35,0h0l0,0a1.27,1.27,0,0,0,.06-.18l0-.13v0h0Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.33,405.74h0l-.33,0h0a1,1,0,0,0-.14-.25l-.12-.13-.06-.06h0a1,1,0,0,1,.33.13A.9.9,0,0,1,210.33,405.74Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.25,407.2h0a.19.19,0,0,1-.1,0l-.19-.08a.65.65,0,0,1-.18-.15.69.69,0,0,1-.11-.13l-.07-.1h0l.31,0h0a1.24,1.24,0,0,0,.1.2l.12.16.12.11Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.42,405.24l0,0-.16.12a1.68,1.68,0,0,0-.18.21v0h0l-.3,0a1,1,0,0,1,.71-.37h0Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.78,406.81a1,1,0,0,1-.17.19.75.75,0,0,1-.18.13l0-.35Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.35,406.77l0,.35a1,1,0,0,1-.29-.38Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.87,405.69l-.32,0,0-.33a.85.85,0,0,1,.17.16Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.48,405.34l0,.32-.3,0A.86.86,0,0,1,209.48,405.34Z",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--uGJA8C--inject-87"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210,409.26a.83.83,0,0,0-.94-.53.79.79,0,0,0-.69.78,1.23,1.23,0,0,0,.08.38,3.14,3.14,0,0,0,.42.73l.22.27,0,0,.34-.31a2.22,2.22,0,0,0,.5-.67A.77.77,0,0,0,210,409.26Zm-.28.29a.52.52,0,1,1-.44-.57A.52.52,0,0,1,209.7,409.55Z",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183,403.38c1.27.07,2.53.16,3.79.25l3.78.3,3.78.34q1.89.18,3.78.39c-1.26-.07-2.53-.16-3.79-.25l-3.78-.3-3.78-.34Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.93,404.47c.63,0,1.27,0,1.9.09l1.89.14,1.89.18c.63.07,1.26.14,1.88.23L188.6,405l-1.9-.14-1.88-.19C184.19,404.63,183.56,404.56,182.93,404.47Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.71,407l3.79.26,3.79.3,3.78.34c1.26.12,2.51.25,3.77.39-1.26-.07-2.52-.16-3.79-.25l-3.78-.3-3.78-.35C185.23,407.27,184,407.15,182.71,407Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.62,408.09c.64,0,1.27.06,1.9.1l1.89.14,1.89.18c.63.07,1.26.14,1.89.23-.64,0-1.27-.06-1.9-.1l-1.89-.14-1.89-.18C183.88,408.25,183.25,408.18,182.62,408.09Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.19,405.94c1.27.07,2.53.16,3.79.25l3.78.3,3.78.35c1.26.12,2.52.24,3.78.39-1.26-.07-2.53-.16-3.79-.26l-3.78-.3-3.78-.34Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.1,407l1.9.09,1.89.14,1.89.18c.63.07,1.26.14,1.88.23-.63,0-1.26-.05-1.89-.09l-1.9-.14-1.89-.18C214.36,407.19,213.73,407.12,213.1,407Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.88,409.57c1.27.07,2.53.16,3.79.25l3.78.3,3.79.34,3.77.39c-1.26-.07-2.52-.16-3.79-.25l-3.78-.3-3.78-.34Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.79,410.66c.63,0,1.27,0,1.9.09l1.89.14,1.89.18c.63.07,1.26.14,1.88.23l-1.89-.09-1.89-.14-1.89-.18C214.05,410.82,213.42,410.75,212.79,410.66Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.01 435.21 263.28 435.21 275.69 369.08 176.42 369.08 164.01 435.21",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.11 362.24 276.97 362.24 275.69 369.08 236.71 369.08 240.11 362.24",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.87 445.13 120.33 437.26 120.33 309.28 200.87 300.55 200.87 445.13",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.89,445.15l-80.58-7.67-.2,0v-.2l.09-64,0-32,0-32v-.12h.11l80.54-8.83.26,0v.26l0,72.38Zm0,0-.18-72.36,0-72.21.26.23-80.56,8.62.11-.12,0,32,0,32,.09,64-.19-.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.65,373c0,13-6.49,23.32-14.5,23.11h-6.62v-1.31l.13-43.5V350h6.49C170.16,349.73,176.65,360,176.65,373Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.48,373c0,13-6.48,23.32-14.48,23.11s-14.49-10.5-14.49-23S148,350.29,156,350,170.48,360,170.48,373Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.46,373c0,7.39-3.17,13.29-7.07,13.17h-4v-.75l.06-24.79v-.73h3.91C161.29,359.76,164.46,365.62,164.46,373Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.79,373c0,7.39-3.16,13.29-7.06,13.17s-7.06-6-7.06-13.1,3.16-13,7.06-13.17S159.79,365.62,159.79,373Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.87,
    y: 300.55,
    width: 4.71,
    height: 144.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.58,
    y: 304.48,
    width: 6.38,
    height: 136.73,
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Padlock--inject-87"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.76,176.19v33.19h-9.38V176.19c0-12.62-9.59-22.88-21.38-22.88s-21.38,10.26-21.38,22.88v33.19h-9.38V176.19c0-18.07,13.8-32.77,30.76-32.77S405.76,158.12,405.76,176.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.25 184.82 353.62 185.2 353.62 209.38 344.25 209.38 344.25 184.82",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.75 187.32 405.75 209.38 396.38 209.38 396.38 186.94 405.75 187.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.23,
    y: 190.48,
    width: 85.55,
    height: 77.61,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375,
    y: 190.48,
    width: 42.77,
    height: 77.61,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.62,232.13l3.58,17H367l3.58-17a7.6,7.6,0,1,1,8,0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-87"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.58,309.5c-.65-2-35.42-47.91-37.8-48.79-.27-.12-15.81,10.94-15.81,10.94-.64.86-30.19-5.38-30.19-5.38l-.29,35.64,53.82-1.15s7.27,4.28,13.92,7.76h0a78.62,78.62,0,0,0,8.75,4.24C291.69,313.45,297.24,311.45,296.58,309.5Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,312.76a76.75,76.75,0,0,1-8.75-4.24h0c-6.65-3.48-13.92-7.76-13.92-7.76l-12,.26-18.75-30.26c4.12.73,7.19,1.17,7.39.89,0,0,15.54-11.06,15.81-10.94,2.38.88,37.15,46.82,37.8,48.79S291.69,313.46,289,312.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.9,309.56c-.69-2-35.62-47.93-38-48.84-.93-.35-8.53,4.35-15.88,10.93l22.55,29.58s20.81,11,23.59,11.73S297.58,311.57,296.9,309.56Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.56,310.3c-6.05-7.55-29.71-38.59-35.11-46.51,0-.07,0-.1.05,0,6.15,7.35,29.56,38.58,35.18,46.45C294.8,310.37,294.69,310.46,294.56,310.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.21,311.26a7.76,7.76,0,0,1-1.62-6,7.54,7.54,0,0,1,2.8-4.85c.05,0,.11.05.07.1a9,9,0,0,0-1.15,10.71A.06.06,0,0,1,285.21,311.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.13,303.06c-2.39-3.05-4-7.45-2.95-11.28,0-.15.25-.09.27,0a54.05,54.05,0,0,0,3.1,11A.25.25,0,0,1,268.13,303.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.87,304.73c-2.39-3.05-4-7.45-3-11.28,0-.15.26-.09.28,0a53.24,53.24,0,0,0,3.1,11A.24.24,0,0,1,270.87,304.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.6,306.4c-2.38-3-4-7.45-3-11.28,0-.14.25-.08.28,0a53.48,53.48,0,0,0,3.09,11A.24.24,0,0,1,273.6,306.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.34,308.07c-2.39-3-4-7.44-2.95-11.27,0-.15.25-.09.27,0a53.6,53.6,0,0,0,3.1,11A.24.24,0,0,1,276.34,308.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.63,271.31c-2.62-3.47,2.76-7.54,5.38-4.07S256.25,274.78,253.63,271.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.77,309c.88-3.3.31-6.86.15-10.2a.47.47,0,0,0-.67-.37.1.1,0,0,0-.16,0,20.34,20.34,0,0,0-5.75,8.79c-.61,2-.38,4.91,2.1,5.49S266.26,310.88,266.77,309ZM264.33,311c-3.59,2.24-3.31-2.74-2.8-4.18a21.2,21.2,0,0,1,1.22-2.71c.94-1.83,2.13-3.49,3.24-5.21,0,1.65.09,3.29.13,4.94C266.16,305.84,266.3,309.8,264.33,311Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.81,288.92c-1.83,1.77-.52,4.39,1,5.78a20.32,20.32,0,0,0,9.45,4.57.12.12,0,0,0,.13-.11.47.47,0,0,0,.38-.66c-1.59-2.94-2.94-6.29-5.39-8.66C260,288.46,257.54,287.24,255.81,288.92Zm7.66,5.61c.82,1.43,1.56,2.89,2.44,4.29a61.11,61.11,0,0,1-5.47-2.79,22.56,22.56,0,0,1-2.44-1.69c-1.18-1-4-5.1.24-5C260.58,289.35,262.49,292.83,263.47,294.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.16,255.34H187s-25.27-12.15-45.62-7.26c-23.33,5.61-26.32,34.92-8.87,45.28C154.6,306.49,252.93,304,252.93,304l-21.26-36S199,261,169.32,262l41.84,5.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.09,270.25a1.33,1.33,0,0,1-.05-.19l0-.15c0-.11-.06-.23-.1-.35a5.78,5.78,0,0,0-.24-.7q-.13-.35-.3-.69a5.16,5.16,0,0,0-.4-.63s0,0-.06,0l0,0-.06,0,0,0c-3.6-.67-28-4.17-31.66-4.58s-7.34-.76-11-1.07a216.44,216.44,0,0,0-22-.79q-1,0-2.07.06a3.69,3.69,0,0,0-.45-.11c-.36-.09-.71-.18-1.06-.24-.67-.13-1.34-.23-2-.33-1.4-.21-2.79-.36-4.18-.62-.08,0-.11.11,0,.13,1.39.31,2.76.71,4.15,1l1.21.25c-2.7.14-5.39.35-8.08.59-.08,0-.09.14,0,.14,3.66-.22,7.35-.24,11-.18s7.28.14,10.92.35c7.36.42,14.71,1.08,22,1.85,4.11.43,29,4.06,33.15,4.24h.05c0,.09.07.19.12.28s.22.45.35.67.23.42.36.62l.21.3.1.15a.83.83,0,0,1,.11.15C233,270.39,233.14,270.33,233.09,270.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.26,301.76c-1.31-2.11-2.44-4.35-3.64-6.52L238,288.71c-2.42-4.34-11.1-18.94-12-20-.05-.06-.16,0-.14.09.41,1.12,5.83,10.79,7.08,12.94,2.49,4.31,5.11,8.54,7.7,12.79.74,1.22,1.5,2.42,2.25,3.63s1.54,2.39,2.23,3.63C245.19,301.91,245.31,301.83,245.26,301.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.79,272.38c-2.17-.52-4.4-.86-6.59-1.27l-6.59-1.24q-6.6-1.23-13.22-2.34c-8.8-1.48-17.63-2.71-26.51-3.56-5-.48-10-.8-15.07-1.17-.1,0-.1.16,0,.17,8.94.4,17.88,1.61,26.74,2.88s17.52,2.65,26.26,4.12l7.4,1.27c2.51.43,5,1,7.53,1.29A.08.08,0,0,0,225.79,272.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.78,426.73c-2.12-.21-54.8-23.88-56.24-26.06-.54-.82,2.46-8.69,6.35-18.1.84-2,1.72-4.13,2.63-6.25,5.87-13.77,12.42-28.25,12.42-28.25l35.28,15.73-13.39,27.83-2.93,6.11s16.11,18.08,17.43,20.63S252.89,426.94,250.78,426.73Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.78,426.73c-2.12-.21-54.8-23.88-56.24-26.06-.66-1,3.91-12.41,9-24.35l34.31,15.31-2.93,6.11s16.11,18.08,17.43,20.63S252.89,426.94,250.78,426.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.78,426.73c-2.12-.21-54.8-23.88-56.24-26.06-.54-.82,2.46-8.69,6.35-18.1l34,15.17s16.11,18.08,17.43,20.63S252.89,426.94,250.78,426.73Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,424.29c-8.73-4.19-44.35-20.25-53.3-23.72-.07,0-.1,0,0,.05,8.57,4.34,44.31,20.11,53.26,23.81C251.09,424.51,251.15,424.37,251,424.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.8,415a7.74,7.74,0,0,0-6.25-.22,7.53,7.53,0,0,0-4.1,3.82c0,.06.08.1.11.05a9,9,0,0,1,10.19-3.54C249.82,415.09,249.87,415,249.8,415Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.93,400.15c-3.51-1.63-8.17-2.23-11.67-.33-.13.08,0,.27.1.26a53.32,53.32,0,0,1,11.43.54A.25.25,0,0,0,237.93,400.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.18,402.44c-3.51-1.63-8.17-2.23-11.67-.33-.13.08,0,.27.1.26a53.32,53.32,0,0,1,11.43.54A.25.25,0,0,0,240.18,402.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.43,404.73c-3.51-1.63-8.17-2.23-11.67-.33-.13.08,0,.27.1.26a53.32,53.32,0,0,1,11.43.54A.25.25,0,0,0,242.43,404.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.68,407c-3.51-1.63-8.17-2.23-11.67-.33-.13.08,0,.27.1.26a53.32,53.32,0,0,1,11.43.54A.25.25,0,0,0,244.68,407Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.69,393.19c-4-1.77-6.73,4.4-2.75,6.17S207.66,395,203.69,393.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,392.44c-1.13-2.29-4-1.85-5.83-.81a20.39,20.39,0,0,0-7.27,7.6.1.1,0,0,0,.06.15c0,.29.17.63.51.57,3.3-.61,6.9-.85,9.92-2.46C245.14,396.56,247.05,394.6,246,392.44ZM238.27,398c-1.61.34-3.23.6-4.83,1a59.23,59.23,0,0,1,4.34-4.34,21.71,21.71,0,0,1,2.36-1.81c1.3-.82,6.09-2.21,4.72,1.79C244.1,396.85,240.2,397.6,238.27,398Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.52,396.59c2.86,1.86,6.43,2.41,9.67,3.3.33.09.57-.24.55-.53.06,0,.11-.07.08-.14a20.27,20.27,0,0,0-6.6-8.19c-1.7-1.2-4.55-1.88-5.87.3S221.85,395.51,223.52,396.59Zm-1.23-3c-1-4.11,3.63-2.31,4.85-1.38a23.2,23.2,0,0,1,2.2,2c1.45,1.47,2.66,3.11,4,4.7-1.57-.53-3.16-.93-4.74-1.41C226.68,397,222.86,395.88,222.29,393.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.33,373.09,244,391s47.23-90.65,48.46-118.4c1-23.62-15.39-32.73-68.53-17.46l-13,.17v9c5.72.76,21,3.15,21,3.15,11.09,4.18,14.66,5.91,14.48,6.28C218.7,329.61,204.33,373.09,204.33,373.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.86,263.78c-1.6,2.13-3.08,4.36-4.5,6.62a95.45,95.45,0,0,0-27-7.12q-3.93-.48-7.87-.7c-.11,0-.1.16,0,.17A118.33,118.33,0,0,1,241,268c2.47.76,4.89,1.65,7.33,2.51-1.71,2.73-3.31,5.52-4.85,8.33A165.91,165.91,0,0,0,235.7,295c-1.28,3.07-2.52,6.15-3.62,9.28,0,.09.12.15.16.06q7.27-16.2,15.87-31.73c1.62-2.92,3.31-5.8,4.9-8.75C253.05,263.8,252.93,263.7,252.86,263.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.87,381.44c-2.31-.9-4.56-2-6.82-3.05l-6.82-3.06c-4.53-2-20.22-8.53-21.52-8.83-.08,0-.12.1-.06.15,1,.66,11.13,5.16,13.42,6.14,4.58,2,9.2,3.77,13.82,5.64,1.32.53,2.65,1,4,1.56s2.67,1,4,1.57C244.9,381.6,245,381.47,244.87,381.44Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.67,267.88c-3.13,5.95-5.8,12.17-8.52,18.32s-5.34,12.27-7.9,18.46Q228.62,323.14,222,342c-2.49,7.12-4.82,14.29-7.09,21.49,0,.1.13.14.16,0,4.21-12.72,8.76-25.33,13.51-37.86s9.79-24.88,15.12-37.13q2.25-5.18,4.56-10.3c1.55-3.42,3.16-6.82,4.6-10.29C252.94,267.85,252.74,267.74,252.67,267.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.66,195.18c4.07,19.27,13.8,40.11,17.21,42.94,5.29,4.37,26,13.09,34.7,15,3.61.78,13.82-14.94,11.33-16.82s-32.63-14.86-34.33-15.72c-.91-.47-12.95-19.29-20-28.36C219,183.71,215.42,189.32,216.66,195.18Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.28,205.28l-16,10.6s-5.18-14.65-4.91-23.21,4.24-7.24,8.6-2.7S236.28,205.28,236.28,205.28Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.28,205.28l-5.69,3.78-10.29,6.82s-5.19-14.65-4.91-23.22c.23-7,2.89-7.38,6.22-4.85A19.76,19.76,0,0,1,224,190C228.34,194.51,236.28,205.28,236.28,205.28Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.16,199a1.6,1.6,0,0,0-1,1.48,1.26,1.26,0,0,1-.58,1.08,1.21,1.21,0,0,1-.66.22c-.27.05-.54.08-.8.15a2.73,2.73,0,0,0,1.68.06,1.61,1.61,0,0,0,1-1.5,1.24,1.24,0,0,1,.62-1.06,1.36,1.36,0,0,1,.67-.19c.27-.06.54-.08.8-.16A3.25,3.25,0,0,0,226.16,199Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.8,203.31c.1-.07.09-.16,0-.1a132.09,132.09,0,0,0-13.42,8.89s0,.07,0,.06C222.78,211,232.63,204.05,233.8,203.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.59,209.06l-10.29,6.82s-5.19-14.65-4.91-23.22c.23-7,2.89-7.38,6.22-4.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.44,254.17c.11.17,56.42,5,57,4.51.84-.72-.47-55.54-7.94-69.18-1.87-3.41-11.39-6.41-16-2.17C188.87,203.72,173.05,253.57,173.44,254.17Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.69,189.22a1.61,1.61,0,0,0-1,1.48,1.26,1.26,0,0,1-.58,1.08,1.4,1.4,0,0,1-.67.22,8.08,8.08,0,0,0-.8.16,3,3,0,0,0,1.68.06,1.64,1.64,0,0,0,1-1.51,1.24,1.24,0,0,1,.61-1.05,1.32,1.32,0,0,1,.67-.2c.27-.05.54-.08.81-.15A3.05,3.05,0,0,0,211.69,189.22Zm-5.15,34.89a1.61,1.61,0,0,0-1,1.48,1.3,1.3,0,0,1-.57,1.09,1.43,1.43,0,0,1-.67.21c-.27.05-.53.09-.8.16a3,3,0,0,0,1.68.06,1.64,1.64,0,0,0,1-1.51,1.27,1.27,0,0,1,.61-1,1.47,1.47,0,0,1,.68-.2c.27,0,.53-.08.8-.15A3.15,3.15,0,0,0,206.54,224.11Zm-12.49,26.51a1.59,1.59,0,0,0-1,1.48,1.28,1.28,0,0,1-.58,1.08,1.4,1.4,0,0,1-.67.22,7.37,7.37,0,0,0-.79.16,2.93,2.93,0,0,0,1.67.06,1.63,1.63,0,0,0,1-1.51,1.3,1.3,0,0,1,.62-1.06,1.43,1.43,0,0,1,.68-.19c.27-.06.53-.08.79-.15A3,3,0,0,0,194.05,250.62Zm31.69-51.39a1.66,1.66,0,0,0-.62,1.26,1.26,1.26,0,0,1-.58,1.08,1.21,1.21,0,0,1-.66.22c-.27.05-.54.08-.8.15a2.73,2.73,0,0,0,1.68.06,1.61,1.61,0,0,0,1-1.5,1.13,1.13,0,0,1,.15-.57C225.85,199.69,225.79,199.46,225.74,199.23Zm-28.88,16a1.6,1.6,0,0,0-1.76.36,1.27,1.27,0,0,1-1.19.31,1.32,1.32,0,0,1-.61-.35c-.22-.15-.43-.31-.68-.45a3.19,3.19,0,0,0,1.13,1.25,1.62,1.62,0,0,0,1.79-.31,1.27,1.27,0,0,1,1.18-.36,1.29,1.29,0,0,1,.61.32,8.09,8.09,0,0,0,.68.46C197.7,216,197.48,215.44,196.86,215.18ZM226,248.93a1.63,1.63,0,0,0-1.76.37,1.28,1.28,0,0,1-1.18.31,1.37,1.37,0,0,1-.62-.34,8,8,0,0,0-.68-.45,3.17,3.17,0,0,0,1.13,1.24,1.6,1.6,0,0,0,1.78-.31,1.28,1.28,0,0,1,1.18-.35,1.13,1.13,0,0,1,.62.32c.23.14.43.32.67.45A2.87,2.87,0,0,0,226,248.93Zm-.91-28.7a1.64,1.64,0,0,0-1.77.37,1.27,1.27,0,0,1-1.18.31,1.42,1.42,0,0,1-.62-.34c-.22-.15-.43-.32-.67-.46a3.16,3.16,0,0,0,1.12,1.25,1.61,1.61,0,0,0,1.79-.31,1.26,1.26,0,0,1,1.17-.36,1.29,1.29,0,0,1,.63.33c.22.14.44.31.67.44C225.87,221,225.65,220.5,225,220.23Zm-17.24,23.4A1.62,1.62,0,0,0,206,244a1.25,1.25,0,0,1-1.18.31,1.42,1.42,0,0,1-.62-.34c-.23-.16-.43-.32-.67-.46a3.09,3.09,0,0,0,1.12,1.25,1.61,1.61,0,0,0,1.78-.31,1.29,1.29,0,0,1,1.18-.36,1.2,1.2,0,0,1,.62.32c.23.15.44.32.68.46C208.63,244.43,208.41,243.9,207.8,243.63Zm-13.74-8.08a1.66,1.66,0,0,0-1.51-1,1.24,1.24,0,0,1-1.05-.61,1.33,1.33,0,0,1-.2-.68c-.05-.26-.09-.53-.15-.8a3.15,3.15,0,0,0-.09,1.68,1.6,1.6,0,0,0,1.48,1,1.31,1.31,0,0,1,1.09.58,1.47,1.47,0,0,1,.21.67c0,.26.08.52.15.79A2.88,2.88,0,0,0,194.06,235.55ZM198,200.43a1.59,1.59,0,0,0-1.05-.92c-.13.19-.24.38-.36.57a1.26,1.26,0,0,1,1,.57,1.33,1.33,0,0,1,.22.67c.05.27.08.54.15.8A2.91,2.91,0,0,0,198,200.43Zm15.29,8.82a1.62,1.62,0,0,0-1.51-1,1.29,1.29,0,0,1-1.06-.62,1.48,1.48,0,0,1-.18-.68c-.06-.26-.09-.53-.16-.8a3.16,3.16,0,0,0-.08,1.68,1.58,1.58,0,0,0,1.47,1,1.26,1.26,0,0,1,1.08.57,1.24,1.24,0,0,1,.22.67c.05.27.08.53.15.8A2.89,2.89,0,0,0,213.26,209.25ZM181,245.6a1.61,1.61,0,0,0-1.5-1,1.24,1.24,0,0,1-1-.61,1.43,1.43,0,0,1-.2-.68c0-.26-.08-.53-.15-.79a3.1,3.1,0,0,0-.09,1.67,1.61,1.61,0,0,0,1.49,1,1.32,1.32,0,0,1,1.08.58,1.3,1.3,0,0,1,.21.67c.06.26.09.53.15.8A2.76,2.76,0,0,0,181,245.6Zm37.91-10a1.61,1.61,0,0,0-1.5-1,1.25,1.25,0,0,1-1-.61,1.43,1.43,0,0,1-.2-.68c0-.26-.08-.53-.15-.8a3.15,3.15,0,0,0-.09,1.68,1.6,1.6,0,0,0,1.49,1,1.31,1.31,0,0,1,1.08.58,1.27,1.27,0,0,1,.21.67c.06.26.09.52.15.79A2.72,2.72,0,0,0,218.89,235.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.55,170h11.64a0,0,0,0,1,0,0v135.7a4.9,4.9,0,0,1-4.9,4.9h-1.84a4.9,4.9,0,0,1-4.9-4.9V170A0,0,0,0,1,273.55,170Z",
    transform: "translate(98.97 561.58) rotate(-101.39)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.55,170h11.64a0,0,0,0,1,0,0v135.7a4.9,4.9,0,0,1-4.9,4.9h-1.84a4.9,4.9,0,0,1-4.9-4.9V170A0,0,0,0,1,273.55,170Z",
    transform: "translate(98.97 561.58) rotate(-101.39)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.28,
    y: 246.72,
    width: 16.41,
    height: 11.64,
    transform: "translate(-45.56 48.1) rotate(-11.39)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.62,254.46l4.07,20.24a26.41,26.41,0,1,0,51.79-10.43L208.41,244a26.41,26.41,0,0,0-51.79,10.43Zm42.2-11.93c1.21,6-2,12.05-7.61,15.5,6.51,1,11.8,5.31,13,11.33,1.63,8.05-4.66,16.13-14,18s-18.28-3.12-19.9-11.17c-1.21-6,2-12.05,7.62-15.49-6.52-1-11.81-5.32-13-11.34-1.63-8.06,4.65-16.11,14-18S197.2,234.47,198.82,242.53Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.62,254.46l4.07,20.24a26.41,26.41,0,1,0,51.79-10.43L208.41,244a26.41,26.41,0,0,0-51.79,10.43Zm42.2-11.93c1.21,6-2,12.05-7.61,15.5,6.51,1,11.8,5.31,13,11.33,1.63,8.05-4.66,16.13-14,18s-18.28-3.12-19.9-11.17c-1.21-6,2-12.05,7.62-15.49-6.52-1-11.81-5.32-13-11.34-1.63-8.06,4.65-16.11,14-18S197.2,234.47,198.82,242.53Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.85,
    y: 250.94,
    width: 26.46,
    height: 5.37,
    rx: 2.26,
    transform: "translate(6.51 512.58) rotate(-101.39)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.85,
    y: 250.94,
    width: 26.46,
    height: 5.37,
    rx: 2.26,
    transform: "translate(6.51 512.58) rotate(-101.39)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.11,
    y: 249.88,
    width: 26.46,
    height: 5.37,
    rx: 2.26,
    transform: "translate(13.85 516.47) rotate(-101.39)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.11,
    y: 249.88,
    width: 26.46,
    height: 5.37,
    rx: 2.26,
    transform: "translate(13.85 516.47) rotate(-101.39)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.85 223.53 312.82 222.73 310.5 211.2 313.89 210.52 315.1 216.53 319.06 215.73 317.85 209.72 320.85 209.11 322.77 218.62 326.74 217.82 324.82 208.31 329.08 207.46 331.64 220.15 335.61 219.35 333.06 206.66 337.09 205.84 340.35 222.07 304.89 229.21 301.63 212.99 306.53 212 308.85 223.53",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.85 223.53 312.82 222.73 310.5 211.2 313.89 210.52 315.1 216.53 319.06 215.73 317.85 209.72 320.85 209.11 322.77 218.62 326.74 217.82 324.82 208.31 329.08 207.46 331.64 220.15 335.61 219.35 333.06 206.66 337.09 205.84 340.35 222.07 304.89 229.21 301.63 212.99 306.53 212 308.85 223.53",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.21,194.91c-7.61,13.5-15.93,39.59-14.42,47.63,1.7,9,27.7,20.58,33.56,22.87,4.2,1.63,9.73-20.66,6.11-22.37-5.26-2.49-18.66-8.56-19.6-10.81s2.27-21.48,3-32.81C210.9,185.17,205.5,187.3,201.21,194.91Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.9,214.57l-19-2.4s5.63-14.48,11.43-20.79,7.93-2.72,8.27,3.57S209.9,214.57,209.9,214.57Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.35,206.16a3.16,3.16,0,0,0-.08,1.68.47.47,0,0,0,0,.1c0-.5.05-1,.08-1.53A2.21,2.21,0,0,0,210.35,206.16ZM198,200.43a1.61,1.61,0,0,0-1.16-1l-.33.6a1.27,1.27,0,0,1,1.05.57,1.33,1.33,0,0,1,.22.67c.05.27.08.54.15.8A2.91,2.91,0,0,0,198,200.43Zm12.2-8.73-.1.08a1.4,1.4,0,0,1-.67.22,8.08,8.08,0,0,0-.8.16,2.94,2.94,0,0,0,1.67.06C210.24,192,210.21,191.87,210.17,191.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.3,211.46c.13,0,.18-.06.06-.08a128.24,128.24,0,0,0-16-2s0,0,0,.06C196,210.08,207.93,211.25,209.3,211.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.53,212.49c-1-.1-1.67-.26-2.66-.32,1.23-2.54,2.39-5.08,3.7-7.59s2.61-5.24,4-7.78c0,0,0-.06-.05,0-.85,1.31-4,6.47-4.57,7.53a63.77,63.77,0,0,0-3.64,8.13,17.1,17.1,0,0,0,3.15.22C193.61,212.64,193.63,212.5,193.53,212.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.62,207.6l.06-1.23h0c.26-1.12.52-2.24.75-3.36a0,0,0,0,0-.09,0c-.23.85-.42,1.71-.63,2.57,0-.5.06-1,.08-1.5,0-1.12,0-2.23,0-3.35a.07.07,0,0,0-.14,0c-.12,1.17-.31,2.33-.38,3.51s-.13,2.37-.2,3.55c-.12,2.25-.25,4.45-.23,6.7-.09,0-1.35-.07-1.44-.05a.08.08,0,0,0,0,.16c.13,0,1.43.22,1.56.23a.16.16,0,0,0,.17-.12C210.39,212.34,210.51,210,210.62,207.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.08,250.67c-1.13-.92-.65-1.52,1.93-1.48s12.76,2.37,13.28-1.25-13.91-6.71-18.21-6.44a68.81,68.81,0,0,0-11.17,2.21C226.6,244.87,232.84,248.32,238.08,250.67Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.57,264.31c7.68,3,17.07,7.2,26.25,5.72a4.61,4.61,0,0,0,2.7-1.36c4.13-.59,5.09-2.72,5.09-2.72,3.68-1.73,4.36-4,4.36-4s4.84-.75,4.88-3.75c0-3.37-6.76-1.66-11.08-3-9.89-3.1-23.09-10.26-25.86-11.44Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.12,259.19a65.42,65.42,0,0,0,8.82,2.22,66.1,66.1,0,0,0,9.95.42.08.08,0,0,1,0,.16,35.24,35.24,0,0,1-18.82-2.66C236.94,259.27,237,259.15,237.12,259.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.38,264.89c2.9.68,8,1.82,17.22,1,0,0,.05,0,0,0a31.57,31.57,0,0,1-17.26-.87C234.17,265,234.19,264.85,234.38,264.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,268a49.74,49.74,0,0,0,13.53.67s0,.05,0,.05c-6,.94-8.27.6-13.59-.55C232.73,268.11,232.78,268,233,268Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.81,241.12c1.85-2.39,3.6,1.17,3.6,1.17s-1.28-5.72,1.59-7.44,4.72,2.72,4.86,3c-.06-.3-1.1-5.59,2-7s4.39,3.24,4.46,3.54c0-.3.48-4.34,3.05-4.89,4.41-1,4.11,10.68,6.59,13.36l6.78-.62a9.1,9.1,0,0,0-3.4,3.87c-1.14,2.26-1.88,3.77-3.16,4.71a3.31,3.31,0,0,1-3.95.11s.16,3.2-2.21,4.4c-1.22.61-3.29-.79-3.29-.79a3.94,3.94,0,0,1-2.16,3.5c-1.73.75-3.53-.77-3.53-.77s-1.13,2.47-3.15,2.66C268.77,260.35,260.83,246.22,264.81,241.12Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.5,243l5.07-.69.57.06c6.48.89,10.8,8.08,6.17,8.81-3.53.56-7.56-4-11.09-2.88h0Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.67,257.09a0,0,0,1,1-.06.05,28.11,28.11,0,0,1-7.32-15c0-.17.26-.29.32-.1A58.07,58.07,0,0,0,275.67,257.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.7,254.64a.06.06,0,0,1-.09.07,26.37,26.37,0,0,1-7-16.91c0-.22.22-.42.24-.16C275.24,241.89,278.76,250.31,281.7,254.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.43,234c.29,6.14,2.51,11.58,5.59,16.83,0,.07-.06.12-.11.07-2.21-2.16-3.82-5.71-4.85-8.58a16.25,16.25,0,0,1-.84-8.31C281.24,233.86,281.43,233.83,281.43,234Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,197.69c-2.42.16-7.56-4.27-9.61-8.05-.14-.26.27-3,.61-6.32.2-2,.37-4.28.38-6.35l13,3.21a33.41,33.41,0,0,0-1.29,7.95,4.63,4.63,0,0,0,.09.86,1.15,1.15,0,0,0,0,.14C222.45,190.74,222.82,197.44,219,197.69Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.18,189a.93.93,0,0,0,0,.14,8.21,8.21,0,0,1-1.34.06c-7.53-.2-9.36-9.48-9.72-12l12.25,3a33.18,33.18,0,0,0-1.3,7.95A5.67,5.67,0,0,0,222.18,189Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.27,161.69c-1.8,4.47-.53,17.94,2.47,21.18,4.36,4.7,12.08,5.79,16.21.42,4-5.21,2.06-22.74-1.36-25.74C222.57,153.12,212.93,155.09,210.27,161.69Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.3,170.55s-.07,0-.06.09c.15.9.16,2-.61,2.36,0,0,0,.06,0,.05C223.62,172.78,223.58,171.38,223.3,170.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.36,169.71c-1.46.08-1.19,3,.17,2.94S223.59,169.64,222.36,169.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.11,169.94s.07,0,.08.07c.05.91.27,1.94,1.12,2.17a0,0,0,0,1,0,0C228.29,172.18,228,170.81,228.11,169.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.83,168.91c1.45-.25,1.84,2.67.5,2.9S227.62,169.12,228.83,168.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.08,168.48a11,11,0,0,0,1.1-.51,1.94,1.94,0,0,0,1-.73.63.63,0,0,0-.17-.74,1.55,1.55,0,0,0-1.56,0,2.25,2.25,0,0,0-1.21,1.1A.66.66,0,0,0,221.08,168.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.74,167.67a9.81,9.81,0,0,1-1.19-.19,1.92,1.92,0,0,1-1.18-.43.62.62,0,0,1,0-.76,1.55,1.55,0,0,1,1.5-.43,2.29,2.29,0,0,1,1.46.74A.66.66,0,0,1,229.74,167.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.71,179.12c.24.2.48.47.81.47a2.54,2.54,0,0,0,1-.32s.06,0,0,0a1.23,1.23,0,0,1-1.1.6,1,1,0,0,1-.79-.74S222.68,179.1,222.71,179.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.41,176.32a3.1,3.1,0,0,0,2.19,1.18,3.83,3.83,0,0,0,1.12-.05l.21,0,.19-.05a.23.23,0,0,0,.17-.22h0a.34.34,0,0,0,0-.1h0V177c0-.7-.22-1.76-.22-1.76.27.11,1.63.57,1.57.21a46.75,46.75,0,0,0-2.07-9.24.08.08,0,0,0-.16,0c.33,2.9,1.17,5.73,1.55,8.64a5.18,5.18,0,0,0-1.5-.3c-.1,0,.35,2,.35,2.35v0a4.3,4.3,0,0,1-3.29-.69C223.41,176.18,223.35,176.25,223.41,176.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.27,177.13a3.74,3.74,0,0,1-1.36,1.28,1.67,1.67,0,0,1-1,.15c-.74-.12-.82-.78-.74-1.37a3.94,3.94,0,0,1,.24-.9A4.79,4.79,0,0,0,226.27,177.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.91,178.41a1.67,1.67,0,0,1-1,.15c-.74-.12-.82-.78-.74-1.37A1.73,1.73,0,0,1,224.91,178.41Z",
    style: {
      fill: "#ff9bbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.56,171.36c.94-.46,2.7-3.52,3.48-4.77s.73-7.35.66-9.16a9.6,9.6,0,0,0-3.39,4.22C209.49,163.64,209.27,167.46,209.56,171.36Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.57,162a4.67,4.67,0,0,1-4.21,1.8,4.79,4.79,0,0,1-3.83-2.67c0-.05-.08,0-.07,0a4.76,4.76,0,0,0,3.86,3,4.81,4.81,0,0,0,4.34-2.11A.06.06,0,1,0,225.57,162Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.14,150.6a7.4,7.4,0,0,0-6,3.73,5.33,5.33,0,0,0-.34,3.46s.11,0,.1,0a5.78,5.78,0,0,1,2.47-5.36,7.45,7.45,0,0,1,6.55-1.12,4.72,4.72,0,0,1,2.64,1.91c.06.09.26,0,.21-.08C224.9,151.46,222.6,150.42,220.14,150.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.23,155.72a6,6,0,0,0-2.71-3.1c-1.72-1-3.6-.71-5.47-.43-.05,0,0,.09,0,.08a8.33,8.33,0,0,1,4.72.3,5.88,5.88,0,0,1,2.87,2.74,5.74,5.74,0,0,1-2,7.25,5.85,5.85,0,0,1-4.58.7c-.06,0-.1.07,0,.09a5.87,5.87,0,0,0,7.23-7.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.61,164.43s-2.8-4.75-.77-7.66c1.15-1.66,5.23-1.63,5.23-1.63a7.32,7.32,0,0,1,4.53-3.31c3.37-.94,7.5.87,7.5.87s3.14-2,6.25-.4c4.32,2.22,4.08,8.67-.07,10.92-2.92,1.59-7.08-.87-7.08-.87-.39.07-4.27,2.65-7.44-.77,0,0-2.35,2.29-4.62.86A3.54,3.54,0,0,1,209.61,164.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.16,172.75s-2.71-4.5-4.73-3.56-.18,7.32,2,8.32a2.33,2.33,0,0,0,3.2-1Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,171s-.05,0,0,.06a5.86,5.86,0,0,1,2.8,3.88,1.29,1.29,0,0,0-1.9-.48.05.05,0,0,0,0,.09,1.44,1.44,0,0,1,1.54.6,7.21,7.21,0,0,1,.67,1.33c.06.15.33.09.28-.08v0C211.58,174.33,210.18,171.36,208,171Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.d409c4948c22cd0c04c2d737218d6a35.svg";
export { ForwardRef as ReactComponent };